import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/AboutPaulo.css';

function AboutPaulo() {
  const { t } = useTranslation();
  const aboutRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    const contentElements = aboutRef.current?.querySelectorAll(
      '.about-paulo-header, .about-paulo-text, .about-paulo-image-container',
    );
    contentElements?.forEach(element => {
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px)';
      element.style.transition = 'all 0.6s ease';
      observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id='aboutPaulo'
      className='about-paulo about-paulo-with-dots'
      ref={aboutRef}
    >
      <div className='dots-paulo-background'></div>
      <div className='about-paulo-container'>
        <div className='section-paulo-header'>
          <h2 className='section-paulo-title'>{t('about_paulo_title')}</h2>
        </div>

        <div className='about-paulo-content'>
          <div className='about-paulo-text'>
            <p>
              {t('about_paulo_p1')}
              <br />
              <br />
              {t('about_paulo_p2')}
              <br />
              <br />
              {t('about_paulo_p3')}
              <br />
              <br />
              {t('about_paulo_p4')}
              <br />
              <br />
              {t('about_paulo_p5')}
            </p>
          </div>
          <div className='about-paulo-image-container'>
            <img src='/Paulo-Cesar.jpg' alt={t('about_paulo_image_alt')} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutPaulo;
